import { render, staticRenderFns } from "./PublicHearingConfirmacao.vue?vue&type=template&id=149ec880&scoped=true&"
import script from "./PublicHearingConfirmacao.vue?vue&type=script&lang=js&"
export * from "./PublicHearingConfirmacao.vue?vue&type=script&lang=js&"
import style0 from "./PublicHearingConfirmacao.vue?vue&type=style&index=0&id=149ec880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149ec880",
  null
  
)

export default component.exports